import { deleteLeasedEquipmentSupplyAlertProfile } from "actions/Utilities/LeasedEquipmentSupplyAlertProfile";
import { toast } from "components/toastNotification";
import { useMutation } from "react-query";

export default function useDeleteSupplyAlertProfile() {
    const { mutate } = useMutation(
        (ids: number[]) => deleteLeasedEquipmentSupplyAlertProfile(ids),
        {
            onSuccess: (res: any) => {
                switch (true) {
                    case res == "Success":
                        toast.fire("Success", "Supply Alert Profile Disabled Successfully", "success");
                        break;
                    case res.includes("Notification insert Failed"):
                        toast.fire(
                            "Success ",
                            `Supply Alert Profile Disabled Successfully, BUT ${res}`,
                            "warning"
                        );
                        break;
                    case res == "Operation Failed!":
                        toast.fire(
                            "Disabling Supply Alert Profile failed ",
                            `Server Error: ${res}`,
                            "error"
                        );
                        break;
                    case res == "Supply Alert Profile not found":
                        toast.fire("Disabling Supply Alert Profile failed ", `Error: ${res}`, "error");
                        break;
                    default:
                        toast.fire("Disabling Supply Alert Profile failed", res.Message, "error");
                }
            },
            onError: (error) => {
                toast.fire("Disabling Supply Alert Profile failed", `Error: ${error}`, "error");
            },
        }
    );

    return mutate;
}
